module.exports = {
  x_tasks: '{x} Aufgaben',
  x_of_y_done: '{x}/{y} erledigt',
  filters: {
    active: 'Aktiv',
    done: 'Abgeschlossen',
  },
  task_details: 'Aufgabendetails',
  preview_comments_disabled: 'In der Vorschau ist die Kommentarfunktion deaktiviert.',
  currently_no_todolists_visible: 'Hier gibt es aktuell keine Aufgaben.',
  todolist: 'Aufgabenliste',
  tasks: 'Aufgaben',
  need_to_upload_at_least_one_file: 'Du musst mindestens eine Datei hochladen um diese Aufgabe abzuschließen.',
}
